// extracted by mini-css-extract-plugin
module.exports = {"navList":"NavFooterList_navList__4s19D","navListInner":"NavFooterList_navListInner__VCKtT","nestedList":"NavFooterList_nestedList__S7YLb","open":"NavFooterList_open__g4CX_"};